import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import HTMLComment from 'react-html-comment';
import { LoggerContext } from '@rmc/webcx-web-libs';

export function CommentLogScript({
	domNode = new DocumentFragment(),
	comment = '',
}: {
	domNode: HTMLElement | DocumentFragment | HTMLOrSVGScriptElement | null;
	comment: string;
}) {
	if (!domNode) return null;

	const portalChild = <HTMLComment text={comment} />;
	const key = comment;
	return createPortal(portalChild, domNode, key);
}

export function Logger({
	domNode,
}: {
	domNode: HTMLElement | null | SVGScriptElement;
}) {
	const { logText } = useContext(LoggerContext);

	return <CommentLogScript domNode={domNode} comment={logText} />;
}
